import { render, staticRenderFns } from "./BuilderNode.vue?vue&type=template&id=307fd54f"
import script from "./BuilderNode.vue?vue&type=script&lang=js"
export * from "./BuilderNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports